import styles from "./styles.module.css";
import { MetaFisica } from "../../../model/PlanoDeTrabalho/CronogramaExecucao";

type Props = {
  metaObj: MetaFisica;
  children?: any;
};

const RowCronoFisico = ({ metaObj, children }: Props) => {
  return (
    <tr className={styles.row}>
      <td className={styles.dozeAvos}>
        {metaObj.etapa}.{metaObj.fase}
      </td>
      <td>{metaObj.descricao}</td>
      <td className={styles.sexto}>
        <strong>Unidade: </strong>
        {metaObj.unidade_medida}
        <hr className={styles.divisao} />
        <strong>Quantidade: </strong>
        {metaObj.quantidade}
      </td>
      <td className={styles.sexto}>
        <strong>Inicio: </strong>
        {new Date(metaObj.inicio).toLocaleDateString("pt-BR", {
          timeZone: "utc",
        })}
        <hr className={styles.divisao} />
        <strong>Fim: </strong>
        {new Date(metaObj.fim).toLocaleDateString("pt-BR", {
          timeZone: "utc",
        })}
      </td>
      {children && <td className={styles.btncoll}>{children}</td>}
    </tr>
  );
};
export default RowCronoFisico;
